import api from '../configs/api.config';
import { WEFResponse } from '../Types';
import {
  ClassificationReviewRequest,
  ClassificationReviewResult,
  RegistrationReviewItem,
  RegistrationReviewQueueFilter
} from '../types/registrationReview.types';

export const getRegistrationReviewQueue = async (filter: RegistrationReviewQueueFilter) => {
  const params = new URLSearchParams();
  if (filter.monitoringListId) params.append('monitoringListId', filter.monitoringListId);
  if (filter.clientId) params.append('clientId', filter.clientId);
  if (filter.includeReviewed) params.append('includeReviewed', 'true');

  const { data } = await api.get<WEFResponse<RegistrationReviewItem[]>>(
    `/RegistrationReview/queue?${params.toString()}`,
    { silent: true }
  );
  return data?.data ?? [];
};

/** Short-lived URL that renders the file inline (img / iframe) instead of downloading it. */
export const getRegistrationViewUrl = async (fileId: string) => {
  const { data } = await api.get<WEFResponse<string>>(
    `/PlateRegistration/file/${fileId}/view-url`,
    { silent: true }
  );
  return data?.data ?? null;
};

export const submitClassificationReview = async (
  plateId: string,
  request: ClassificationReviewRequest
) => {
  const { data } = await api.post<WEFResponse<ClassificationReviewResult>>(
    `/RegistrationReview/${plateId}`,
    request,
    { silent: true }
  );
  return data?.data;
};
